import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { ID_ESTADO_ENTREGADO } from '/src/constants/pedidoEstados'
import { Reclamar } from '../../pages/reclamar/Reclamar'
import DetallePago from '../../pedidos/DetallePago'
import DetallePie from '../../pedidos/DetallePie'
import Descripcion from '../../publicaciones/Descripcion'
import DetalleCabecera from '../../publicaciones/DetalleCabecera'
import * as mensajesService from '../../servicios/mensajesService'
import * as pedidosService from '../../servicios/pedidosService'
import BordeDetalle from '../../ui/BordeDetalle'
import DetalleCobro from '../../ventas/DetalleCobro'
import { DetalleEstadoPedido } from '../../ventas/DetalleEstadoPedido'
import { MensajeriaNew } from '../mensajeria/MensajeriaNew'

const PedidoItemDetalle = () => {
  const usuario = parseInt(localStorage.getItem('idUsuario'))
  const { idPedidoItem } = useParams()

  const navigate = useNavigate()

  const [mensajes, setMensajes] = useState([])
  const [pedido, setPedido] = useState({})
  const [esVentas, setEsVentas] = useState(false)
  const [estados, setEstados] = useState([])
  const [reclamo, setReclamo] = useState(false)

  const buscarMensajes = async (idComprador) => {
    try {
      const { data } = await mensajesService.buscarPorPedidoItem(
        idPedidoItem,
        idComprador ?? pedido.idComprador
      )
      setMensajes(data.sort((a, b) => new Date(a.fechaEscrito) - new Date(b.fechaEscrito)))
    } catch {
      setMensajes([])
    }
  }

  const buscarPedido = async () => {
    try {
      const pedidoResp = (await pedidosService.buscarPorPedidoItem(idPedidoItem)).data
      setEsVentas(pedidoResp.idVendedor === usuario)
      setEstados(pedidoResp.estados)
      const pedidoAux = {
        ...pedidoResp.pedidoItems[0],
        fechaPedido: pedidoResp.fechaPedido,
        idComprador: pedidoResp.idComprador,
        idPedido: pedidoResp.idPedido
      }
      setPedido(pedidoAux)

      buscarMensajes(pedidoResp.idComprador)
    } catch {
      setPedido({})
    }
  }

  const actualizarPedido = async () => {
    await buscarPedido()
  }

  useEffect(() => {
    buscarPedido()
  }, [idPedidoItem])

  const navegar = () => {
    const navegarA = esVentas ? '/Ventas' : '/Pedidos'
    navigate(navegarA)
  }

  return (
    Object.keys(pedido).length > 0 && (
      <BordeDetalle titulo={'Detalle Compras'} onCerrarClick={() => navegar()}>
        <DetalleCabecera detalle={pedido} esVentas={esVentas} permiteComprar={false} />
        <Descripcion descripcion={pedido.descripcion} />
        <DetallePago fechaPedido={pedido.fechaPedido} pedidoItem={pedido} esVentas={esVentas} />
        {esVentas && (
          <>
            <DetalleEstadoPedido
              pedido={pedido}
              estados={estados}
              onActualizar={actualizarPedido}
            />
            <DetalleCobro
              cantidad={pedido?.cantidad}
              precio={pedido?.precioUnitario}
              porcentajeComision={pedido?.comision}
              precioExposicion={pedido?.precioExposicion}
              exposicion={pedido?.exposicion}
              monedaSimbolo={pedido?.monedaSimbolo}
            />
            <hr />
          </>
        )}
        <Reclamar
          reclamo={reclamo}
          setReclamo={setReclamo}
          idComprador={pedido.idComprador}
          idVendedor={pedido.idVendedor}
          tipoDoc={'pedido'}
          id={idPedidoItem}
          actualizarMensajes={buscarMensajes}
          pedido={pedido}
        />
        <MensajeriaNew
          titulo={'Mensajería interna'}
          id={idPedidoItem}
          tipoDoc={'pedido'}
          idVendedor={pedido.idVendedor}
          idComprador={pedido.idComprador || usuario}
          mensajes={mensajes}
          tipoMensajes={'chat'}
          usuario={usuario}
          actualizarMensajes={buscarMensajes}
          pedidoEntregado={pedido.idPedidoItemEstado === ID_ESTADO_ENTREGADO}
        />
        <DetallePie
          idPublicacion={pedido.idPublicacion}
          idEstadoPedidoItem={pedido.idPedidoItemEstado}
          setReclamo={setReclamo}
          esVentas={esVentas}
        />
      </BordeDetalle>
    )
  )
}

export default PedidoItemDetalle
